import { z } from "zod";
import { MFA } from "@/core/types/mfa.type";

export const mfaFormSchema = z.object({
	preferred: z.enum<readonly ["email", "sms", "totp"]>([MFA.EMAIL, MFA.SMS, MFA.TOTP], {
    	message: "mfa.required"
  })
});


export type MfaFormData = z.infer<typeof mfaFormSchema>;
